import React from 'react'
import { selectAuthData } from '@/features/auth/store'
import { useAppSelector } from '@/store'

export const useAuth = () => {
  return useAppSelector(selectAuthData)
}
